module.exports = __webpack_public_path__ + "img/ot-slp_pendle_eth-usdc.d4cb80de.png";